module.exports = __WEBPACK_EXTERNAL_MODULE_20__;


//////////////////
// WEBPACK FOOTER
// external "ca-ui-carbon"
// module id = 20
// module chunks = 0 1